import { render, staticRenderFns } from "./Hello.vue?vue&type=template&id=7d16d236&scoped=true&lang=pug"
import script from "./Hello.vue?vue&type=script&lang=ts"
export * from "./Hello.vue?vue&type=script&lang=ts"
import style0 from "./Hello.vue?vue&type=style&index=0&id=7d16d236&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d16d236",
  null
  
)

/* custom blocks */
import block0 from "./Hello.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fcomponents%2FWidgets%2FHighlights%2FAssessment%2FHighlight%2FHello.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports